module.exports = __webpack_public_path__ + "static/media/autotuner.83788871.png";